/**
 * @generated SignedSource<<46bce2d8a957e8072c1e93c604f1d98f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppClipNotifications_brand$data = {
  readonly appConfig: {
    readonly appClipAutomatedNotifications: {
      readonly " $fragmentSpreads": FragmentRefs<"AutomatedNotificationsForm_automatedNotifications">;
    };
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AppClipLinkGenerator_brand">;
  readonly " $fragmentType": "AppClipNotifications_brand";
};
export type AppClipNotifications_brand$key = {
  readonly " $data"?: AppClipNotifications_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppClipNotifications_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppClipNotifications_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GraphQLAutomatedNotificationConnection",
          "kind": "LinkedField",
          "name": "appClipAutomatedNotifications",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "AutomatedNotificationsForm_automatedNotifications"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AppClipLinkGenerator_brand"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "b40d795a7f81297db96b71690f0e2531";

export default node;
